module.exports = __webpack_public_path__ + "img/sting_duets.ea603602.jpg";